<!--begin::Card-->
<div class="card">
  <!--begin::Card header-->
  <div class="card-header border-0 pt-6">
    <!--begin::Card title-->
    <div class="card-title">
      <!--begin::Search-->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="loadInquiries(1, searchTerm)"
               class="form-control form-control-solid w-250px ps-13" placeholder="Search inquiries..." />
      </div>
      <!--end::Search-->
    </div>
    <!--begin::Card title-->
    <!--begin::Card toolbar-->
    <div class="card-toolbar">
      <!--begin::Toolbar-->
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <button type="button" class="btn btn-sm btn-primary" (click)="loadInquiries(1, searchTerm)">
          <i class="ki-duotone ki-arrows-circle fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>Refresh
        </button>
      </div>
      <!--end::Toolbar-->
    </div>
    <!--end::Card toolbar-->
  </div>
  <!--end::Card header-->

  <!--begin::Card body-->
  <div class="card-body pt-0">
    <!--begin::Loading-->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!--end::Loading-->

    <!--begin::Table-->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
            <th class="text-start min-w-200px">Make/Model/Year/Stock Number</th>
            <th class="text-start min-w-100px">Inq Source</th>
            <th class="text-start min-w-150px">Inq Created At</th>
            <th class="text-start min-w-200px">Customer</th>
            <th class="text-start min-w-100px">Reply Status</th>
            <th class="text-start min-w-100px">Forward Status</th>
            <th class="text-start min-w-100px">Matching Alerts</th>
          </tr>
        </thead>
        <tbody>
          <!-- No Data Row -->
          <tr *ngIf="!isLoading && inquiries.length === 0">
            <td colspan="7" class="text-center py-10">
              <div class="text-muted">No inquiries found</div>
            </td>
          </tr>

          <!-- Data rows -->
          <ng-container *ngFor="let inquiry of inquiries; trackBy: trackByInquiryId">
            <!-- Main inquiry row -->
            <tr>
              <td class="text-start">
                <div class="d-flex flex-column">
                  <div class="fw-bold text-gray-800">{{ getVehicleInfo(inquiry) }}</div>
                  <div class="text-muted fs-7">{{ getVehicleDetails(inquiry) }}</div>
                  <div class="text-primary fs-7 fw-bold">Budget: {{ getBudget(inquiry) }}</div>
                </div>
              </td>
              <td class="text-start">
                <span class="badge badge-light-primary">{{ getInquirySource(inquiry) }}</span>
              </td>
              <td class="text-start">
                {{ formatDate(inquiry.created_at) }}
              </td>
              <td class="text-start">
                <div class="d-flex flex-column">
                  <div class="fw-bold text-gray-800">{{ inquiry.name || '-' }}</div>
                  <div class="text-muted fs-7">{{ inquiry.email || '-' }}</div>
                  <div class="text-muted fs-7">Tel: {{ inquiry.phone || '-' }}</div>
                </div>
              </td>
              <td class="text-start">
                <span class="badge"
                      [ngClass]="getReplyStatus(inquiry) === 'Pending' ? 'badge-light-warning' : 'badge-light-success'">
                  {{ getReplyStatus(inquiry) }}
                </span>
              </td>
              <td class="text-start">
                <span class="badge"
                      [ngClass]="getForwardStatus(inquiry) === 'Forwarded' ? 'badge-light-success' : 'badge-light-danger'">
                  {{ getForwardStatus(inquiry) }}
                </span>
              </td>
              <td class="text-start">
                -
              </td>
            </tr>

            <!-- Message and actions row -->
            <tr class="bg-light-primary">
              <td class="text-start">
                <div class="text-gray-700 fs-7">
                  {{ inquiry.message || 'No message' }}
                </div>
              </td>
              <td colspan="6" class="text-start">
                <div class="d-flex flex-wrap gap-2">
                  <button type="button" class="btn btn-sm btn-primary" (click)="onReplyClick(inquiry)">
                    Reply
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onCloseInquiryClick(inquiry)">
                    Close Inquiry
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onForwardInquiryClick(inquiry)">
                    Forward Inquiry
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onTranslateClick(inquiry)">
                    Translate
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onStockClick(inquiry)">
                    Stock
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onOnePriceClick(inquiry)">
                    One Price
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="onAuctionClick(inquiry)">
                    Auction
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <!--end::Table-->
  </div>
  <!--end::Card body-->

  <!-- Pagination -->
  <div class="card-footer" *ngIf="!isLoading && inquiries.length > 0">
    <app-pagination
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
<!--end::Card-->

<!-- Send Inquiry Reply Modal -->
<app-send-inquiry-reply
  (replyAdded)="onReplyAdded()">
</app-send-inquiry-reply>

<!-- Forward Inquiry to Sales Person Modal -->
<app-inquiry-sales-person
  (inquiryForwarded)="onInquiryForwarded()">
</app-inquiry-sales-person>
